import React, { Component } from 'react';
import '../styles/GlobalStyle.css';
import ColType from '../Types';
import { db, firebase } from '../firebase/Firebase';
import { Form, Input, Button, Icon, Modal, notification, DatePicker } from 'antd';
import moment from 'moment';

const { TextArea } = Input;
const FormItem = Form.Item;

const successMessage = (description) => {
    notification.open({
        type: 'success',
        message: description,
        placement: 'bottomRight'
    });
};

const errorMessage = (description) => {
    notification.open({
        type: 'error',
        message: description,
        placement: 'bottomRight'
    });
};

class ConsultationReportUpdateForm extends Component {
    state = {
        modalVisible: false,
        submitting: false,
        formData: [
            {
                label: 'First name',
                fieldDecorator: 'firstName',
                placeholder: 'First name...',
                type: 'input',
                required: true
            },
            {
                label: 'Last name',
                fieldDecorator: 'lastName',
                placeholder: 'Last name...',
                type: 'input',
                required: true
            },
            {
                label: 'Description of how the professional learning plan was supported',
                fieldDecorator: 'description',
                placeholder: 'Description...',
                type: 'textarea',
                required: true
            }
        ]
    };

    componentDidMount() {
        if (this.props.report) {
            let formObj = {};
            for (let formVal of this.state.formData) {
                if (this.props.report.hasOwnProperty(formVal.fieldDecorator)) {
                    if (formVal.type === 'date' && this.props.report[formVal.fieldDecorator]) {
                        formObj[formVal.fieldDecorator] = moment(this.props.report[formVal.fieldDecorator].toDate());
                    } else {
                        formObj[formVal.fieldDecorator] = this.props.report[formVal.fieldDecorator];
                    }
                }
            }
            this.props.form.setFieldsValue(formObj);
        }
    }

    showModal = () => {
        this.setState({ modalVisible: true });
    };

    handleOk = () => {
        this.setState({ modalVisible: false });
    };

    handleCancel = () => {
        this.setState({ modalVisible: false });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!(this.props.schoolId && this.props.districtId && this.props.report)) {
            console.error('missing props', this.props);
            return;
        }

        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ submitting: true });

                db.collection(ColType.consultationReport)
                    .doc(this.props.report.id)
                    .update(values)
                    .then(() => {
                        successMessage('Report edited successfully.');
                        this.setState({ submitting: false });
                        this.handleCancel();
                    })
                    .catch((error) => {
                        console.error("Error updating document: ", error);
                        errorMessage('Error editing report, please try again.');
                        this.setState({ submitting: false });
                    });
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemBlockLayout = {
            labelCol: { xs: { span: 24 }, sm: { span: 24 } },
            wrapperCol: { xs: { span: 24 }, sm: { span: 24 } },
        };

        return (
            <div>
                <Button type="default" className="lg-btn mr-1" onClick={this.showModal}>
                    <Icon type="edit" /> Edit
                </Button>
                <Modal
                    title="Edit consultation report"
                    visible={this.state.modalVisible}
                    width={700}
                    footer={null}
                    onCancel={this.handleCancel}
                >
                    <Form onSubmit={this.handleSubmit} className="block-label-form">
                        {this.state.formData.map((item, index) => (
                            <FormItem {...formItemBlockLayout} label={item.label + ':'} key={index}>
                                {getFieldDecorator(item.fieldDecorator, {
                                    rules: [{ required: item.required, message: item.required ? 'Required.' : '' }],
                                })(
                                    item.type === 'input' ? (
                                        <Input size="large" placeholder={item.placeholder} />
                                    ) : item.type === 'textarea' ? (
                                        <TextArea rows={8} size="large" placeholder={item.placeholder} />
                                    ) : item.type === 'date' ? (
                                        <DatePicker size="large" style={{ width: '100%' }} />
                                    ) : null
                                )}
                            </FormItem>
                        ))}

                        <FormItem className="mb-0">
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="lg-btn float-right"
                                disabled={this.state.submitting}
                            >
                                {this.state.submitting ?
                                    <span><Icon type="loading" className="mr-1" /> Editing...</span> :
                                    <span><Icon type="edit" /> Edit</span>}
                            </Button>
                        </FormItem>
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default Form.create()(ConsultationReportUpdateForm);